import React from 'react';
import './seo.css';
import categoriesData from './categories.seo.json';
import { ISeoDictionaries } from './seo.models';

interface SeoProps {
  selectedGenders: string[];
  selectedClothes: string[];
  selectedTags: string[];
}

const Seo: React.FC<SeoProps> = ({ selectedGenders, selectedClothes, selectedTags }) => {
  const data: ISeoDictionaries = categoriesData;

  const getDynamicSeoText = (): JSX.Element | null => {
    if (selectedGenders.length !== 1 || selectedClothes.length > 0 || selectedTags.length > 0) return null;

    const gender = selectedGenders[0];

    switch (gender) {
      case 'kobieta':
        return (
          <>
            <h2 className="sectionTitle">Polskie marki odzieżowe dla kobiet w jednym miejscu</h2>
            <div className="description-text">
              <b>Odzież damska polskie marki</b> – odkryj katalog lokalnych producentów, którzy tworzą ubrania 
              szyte w Polsce. Znajdziesz tu marki oferujące <b>t-shirty szyte w Polsce</b>, <b>polską bieliznę</b>, 
              jedwabne apaszki, a także ubrania <b>homewear wyprodukowane w Polsce</b>. Jeśli interesuje Cię 
              <b>polska marka odzieżowa</b> tworząca <b>ubrania petite</b> dla kobiet, sukienki letnie czy eleganckie 
              ubrania, jesteś w dobrym miejscu. W Szafie Polskiej prezentujemy również <b>biżuterię polskich 
              marek</b> jak i akcesoria tworzone w Polsce. Poznaj lokalne ubrania z naturalnych tkanin – od 
              tanich marek odzieżowych po odzież premium.
            </div>
          </>
        );
      case 'mezczyzna':
        return (
          <>
            <h2 className="sectionTitle">Polskie marki odzieżowe dla mężczyzn w jednym miejscu</h2>
            <div className="description-text">
             <b>Ubrania polskich marek dla mężczyzn</b> – Szafa Polska to katalog, w którym odkryjesz <b>odzież 
             męską szytą w Polsce</b>. Wśród propozycji znajdziesz <b>polskie t-shirty męskie</b>, 
             spodnie męskie <b> szyte w Polsce</b>, a także marki oferujące zarówno wygodne, 
             casualowe ubrania, jak i polskie marki produkujące eleganckie ubrania. 
             Jeśli szukasz basicowych ubrań męskich szytych w Polsce, sprawdź nasz katalog i 
             poznaj jakość lokalnych producentów.
            </div>
          </>
        );
      case 'dziecko':
        return (
          <>
            <h2 className="sectionTitle">Polskie marki odzieżowe dziecięce w jednym miejscu</h2>
            <div className="description-text">
              <b>Odzież dziecięca polskie marki</b> – w naszym katalogu znajdziesz wyłącznie <b>ubrania dla 
              dzieci szyte w Polsce</b>. Prezentujemy polskie marki odzieżowe, które tworzą <b>t-shirty 
              dziecięce</b> szyte w Polsce, letnie ubranka dla dzieci, a także leginsy dziecięce. 
              Wyszukaj polską markę odzieżową produkującą sukienki, spodnie, kurtki i swetry dziecięce. 
              Dla rodziców szukających jakości i bezpieczeństwa prezentujemy polskie marki oferujące wygodne ubrania dla dzieci, 
              również od <b>tańszych polskich marek</b>.
            </div>
          </>
        );
      default:
      return null;
    }
  };

  const dynamicSeoText = getDynamicSeoText();

  const getGeneralSeoText = (): JSX.Element => (
    <>
      <h2 className="sectionTitle">Polskie marki odzieżowe w jednym miejscu</h2>
      <div className="description-text">
        Kupuj lokalnie. Wspieraj polskich producentów ubrań. Wybierz polską markę!
      </div>
      <div className="description-text">
        <b>Polskie marki odzieżowe</b> zyskują na popularności. Polska marka odzieżowa produkująca ubrania dobrej jakości
        jest coraz częściej poszukiwana przez konsumenta. Konsumenci zwracają uwagę na proces produkcyjny ubrania i
        wybierają ubrania szyte w Polsce. Polskie ubrania są coraz chętniej poszukiwane na rynku, a rynek polskich firm
        odzieżowych zyskuje na popularności.
      </div>
      <div className="description-text">
        Ubrania <b>wyprodukowane w Polsce</b> kojarzą się z dobrą jakością i wspieraniem lokalności. Ze względu na
        krótszy łańcuch dostaw, doceniany jest też mniejszy wpływ produkcji ubrań na środowisko.
      </div>
      <div className="description-text">
        Dużą zaletą <b>polskich marek odzieżowych</b> jest większa transparentność procesu produkcyjnego. Tym co wyróżnia
        polskie marki odzieżowe jest także możliwość spotkania się z polskimi producentami odzieży osobiście na różnego
        rodzaju wydarzeniach, targach co w przypadku sieciówek jest wręcz niemożliwe.
      </div>
      <div className="description-text">
        Na rynku dostępny jest szeroki wybór marek oferujących polskie ubrania – od marek tanich, przystępnych cenowo,
        budżetowych kolekcji po ekskluzywne marki premium, a każda polska marka ubraniowa stawia na ubrania dobrej jakości
        i unikalny design.
      </div>
    </>
  );

  
  const getStoresSeoText = (): JSX.Element => (
    <> <div>
        <b>Sklepy z polskimi ubraniami</b>
        <div className="stores-options">
          {data.stores.map((category, index) => (
            <div className="item" key={category.name} aria-label={category.ariaLabel}>
              {category.name}
              {index < data.stores.length - 1 ? (
                <span className="separator">• </span>
              ) : (
                <span className="separator">&nbsp;</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );

  return (
    <div className="seoSection">
      <div className="seoContent">
        <div className="column1">
          {dynamicSeoText && (dynamicSeoText)}
          {getGeneralSeoText()}
          {!dynamicSeoText && (getStoresSeoText())}
        </div>

        <div className="column2">
          {!dynamicSeoText && (
            <div className="seoGroup" data-test="gender">
              <h2 className="title">Polskie Ubrania Dla Ciebie i Twoich Bliskich</h2>
              {data.genders.map((category) => (
                <div className="option" key={category.code}>
                  <div className="option-title">
                    <a href={`/filtry/${category.code};g`}>
                      <b>{category.title}</b>
                    </a>
                  </div>
                  <div className="description">{category.description}</div>
                </div>
              ))}
            </div>
          )}

          <div className="seoGroup" data-test="clothesType">
            <h2 className="title">Filtruj polskie ubrania według typu</h2>
            <div className="clothes-options">
              {data.clothesTypes.map((category, index) => (
                <div className="item" key={category.code}>
                  <a
                    href={`/filtry/${category.code};tc`}
                    className="option-title"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={category.ariaLabel}
                  >
                    {category.ariaLabel}
                  </a>
                  {index < data.clothesTypes.length - 1 ? (
                    <span className="separator">• </span>
                  ) : (
                    <span className="separator">&nbsp;</span>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="seoGroup" data-test="tags">
            <h2 className="title">Znajdź polskie ubrania, jakich szukasz</h2>
            <div className="tags-options">
              {data.tags.map((category, index) => (
                <div className="item" key={category.code}>
                  <a
                    href={`/filtry/${category.code};t`}
                    className="option-title"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={category.ariaLabel}
                  >
                    {category.ariaLabel}
                  </a>
                  {index < data.tags.length - 1 ? (
                    <span className="separator">• </span>
                  ) : (
                    <span className="separator">&nbsp;</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Seo;
